/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { notificationArchivedConfig } from '../../config/notifications.config';

export interface IStaticArchivedPagePluginMethods extends IPluginMethodMap {
  getStaticArchivedPageSync(args?: any): any;
}

export class StaticArchivedPagePlugin implements IAgentPlugin {
  readonly methods: IStaticArchivedPagePluginMethods;

  constructor() {
    this.methods = {
      getStaticArchivedPageSync: this.getStaticArchivedPageSync.bind(this),
    };
  }

  getStaticArchivedPageSync(args?: any) {
    return {
      notifications: notificationArchivedConfig,
    };
  }
}
